"use client";
import { Post } from "@/constants/types";
import { useLanguage } from "@/context/LanguageContext";
import React from "react";
import ProgressiveImage from "../ui/ProgressiveImage";
import { dateFormat, limitText } from "@/utils";
import Link from "next/link";

const BlogCard = ({ col = 4, post }: { col?: number; post: Post }) => {
  const { t } = useLanguage();
  return (
    <div
      className={`col-xl-${col} col-lg-${col} col-md-6 mb-30 wow tpfadeUp`}
      data-wow-duration=".9s"
      data-wow-delay=".3s"
    >
      <div className="tp-blog-2__item">
        <div className="tp-blog-2__thumb p-relative">
          <ProgressiveImage url={post?.image} />
        </div>
        <div className="tp-blog-2__content">
          <div className="tp-blog-2__tag">
            <span>
              <i className="flaticon-tag"></i>
              {limitText(post?.category?.name, 20)}
            </span>
          </div>
          <Link href={`/blog/${post.slug}`}>
            <h4 className="tp-blog-2__title-sm">
              {limitText(post?.title, 40)}
            </h4>
          </Link>
          <span className="tp-blog-2__meta">
            {dateFormat(post?.created_at)}
          </span>
          <Link href={`/blog/${post.slug}`}>
            <div className="tp-blog-2__link text-center">
              <span>
                {t("ReadMore")}
                <i className="flaticon-arrow-right"></i>
              </span>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
